import { Turbo } from '@hotwired/turbo-rails'

Turbo.config.forms.mode = 'optin'

Turbo.StreamActions.redirect = function() {
  Turbo.visit(this.target)
}
